import { createReducer, on, Action } from '@ngrx/store';
import {
  ApiError,
  ApplicantImageResponse,
  ApplicantImageUploadOperationResponse,
} from '../../client/src';
import { LoadState } from '@nx-ng/types';
import { ImageActions } from '../../actions';
import { from } from 'rxjs';

export interface ICheckoutImageState {
  loadedImage?: Blob;
  loaded: LoadState;
  loadError?: ApiError | string;
  uploadResponse?: ApplicantImageUploadOperationResponse;
  updated: LoadState;
  updateError?: ApiError | string;
}

export const initialState: ICheckoutImageState = {
  updated: LoadState.NOT_LOADED,
  loaded: LoadState.NOT_LOADED,
};

const imageReducer = createReducer(
  initialState,
  on(ImageActions.checkoutAPI_loadImageSuccess, (state, { blob }) => {
    return { ...state, loaded: LoadState.LOADED, loadedImage: blob };
  }),
  on(ImageActions.checkoutAPI_loadImageFailure, (state, { error }) => ({
    ...state,
    loaded: LoadState.FAILED,
    loadError: error,
  })),
  on(ImageActions.checkoutAPI_loadImage, (state) => ({
    ...state,
    loaded: LoadState.LOADING,
    loadError: undefined,
  })),
  on(ImageActions.checkoutAPI_uploadImageSuccess, (state, { response }) => ({
    ...state,
    updated: LoadState.LOADED,
    uploadResponse: response,
  })),
  on(ImageActions.checkoutAPI_uploadImageFailure, (state, { error }) => ({
    ...state,
    updated: LoadState.FAILED,
    updateError: error,
  })),
  on(ImageActions.checkoutAPI_uploadImage, (state) => ({
    ...state,
    updated: LoadState.LOADING,
    updateError: undefined,
  }))
);

export function reducer(
  state: ICheckoutImageState | undefined,
  action: Action
) {
  return imageReducer(state, action);
}
